import { render, staticRenderFns } from "./AuthManagement.vue?vue&type=template&id=35e263b3&"
import script from "./AuthManagement.vue?vue&type=script&lang=ts&"
export * from "./AuthManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports